var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { makeStyles } from '@material-ui/core';
import { getSpellCategory } from '@timeflies/common';
import clsx from 'clsx';
import React from 'react';
import { FeedbackSpell } from '../feedback-spell';
import { FeedbackEffect } from './feedback-effect';
import { FeedbackEffectCondensed } from './feedback-effect-condensed';
var useStyles = makeStyles(function () { return ({
    "@keyframes opacityAnim": {
        from: {
            opacity: 0.75
        },
        to: {
            opacity: 1
        }
    },
    root: function (_a) {
        var _b = _a.opacity, opacity = _b === void 0 ? 'normal' : _b;
        return ({
            opacity: opacity === 'low' ? 0.75 : 1,
        });
    },
    rootAnimated: {
        animationName: '$opacityAnim',
        animationDuration: '250ms',
        animationIterationCount: 'infinite',
        animationDirection: 'alternate',
        animationTimingFunction: 'steps(2, jump-none)'
    }
}); });
export var FeedbackEffectsStack = function (_a) {
    var _b;
    var spellRole = _a.spellRole, _c = _a.variables, variables = _c === void 0 ? {} : _c, spellInfos = _a.spellInfos, condensed = _a.condensed, opacity = _a.opacity;
    var classes = useStyles({ opacity: opacity });
    var spellCategory = getSpellCategory(spellRole);
    var renderRegularEffects = function () { return Object.entries(variables)
        .map(function (_a) {
        var name = _a[0], value = _a[1];
        return (React.createElement(FeedbackEffect, { key: name, spellCategory: spellCategory, variableName: name, value: value }));
    }); };
    var renderCondensedEffects = function () { return (React.createElement(FeedbackEffectCondensed, { spellCategory: spellCategory, variableNameList: Object.keys(variables) })); };
    return React.createElement("div", { className: clsx(classes.root, (_b = {},
            _b[classes.rootAnimated] = opacity === 'animate',
            _b)) },
        condensed
            ? renderCondensedEffects()
            : renderRegularEffects(),
        spellInfos && (React.createElement(FeedbackSpell, __assign({ spellRole: spellRole }, spellInfos))));
};
